<template>
  <div v-if="loggedIn" class="payment">
    <EplNewPaymentSummaryCard :payableAmount="payableAmount" />
    <p class="payment__title">Select a Payment Mode</p>
    <template
      v-if="user.features.loyalty.repayment_enabled &&user.features.loyalty.redeemable_points>0"
    >
      <div class="payment__redeem-points">
        <input
          class="payment__redeem-points__checkbox"
          type="checkbox"
          name="reward-points"
          id="reward-points"
          v-model="isLoyaltyPointsSelected"
        />
        <label for="reward-points" class="payment__redeem-points__checkbox__label">
          Redeem Reward Points
          <span class="payment__redeem-points__checkbox__label__available">
            Available
            <span
              class="payment__redeem-points__checkbox__label__available--amount"
            >{{(user.features.loyalty.redeemable_points)|formatCurrency}}</span>
          </span>
        </label>
      </div>
    </template>
    <div
      class="payment__confirmation"
      v-if="user.features.loyalty.repayment_enabled&&user.features.loyalty.redeemable_points>=payableAmount&&isLoyaltyPointsSelected"
    >
      <p class="payment__confirmation__title">Payment Summary</p>
      <hr />
      <p class="payment__confirmation__detail-points">
        <span class="payment__confirmation__detail-points__title">Total Amount</span>
        <span class="payment__confirmation__detail-points__amount">{{payableAmount|formatCurrency}}</span>
      </p>
      <p class="payment__confirmation__detail-points">
        <span class="payment__confirmation__detail-points__title">Use Reward Points</span>
        <span
          class="payment__confirmation__detail-points__amount payment__confirmation__detail-points__amount--primary"
        >-{{(user.features.loyalty.redeemable_points>payableAmount?payableAmount:user.features.loyalty.redeemable_points)|formatCurrency}}</span>
      </p>
      <hr />
      <p class="payment__confirmation__detail-summary">
        <span class="payment__confirmation__detail-summary__title">Total Outstanding</span>
        <span class="payment__confirmation__detail-summary__amount">{{0|formatCurrency}}</span>
      </p>
      <ActionButton title="Confirm" @click="payViaLoyalty" />
    </div>
    <template v-else>
      <EplNewPaymentModeCard
        v-for="(paymentMethod, index) in paymentMethods"
        :key="index"
        :paymentMethod="paymentMethod"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EplNewPaymentModeCard from "@/components/EplNewPaymentModeCard";
import EplNewPaymentSummaryCard from "@/components/EplNewPaymentSummaryCard";
import ActionButton from "@/components/ActionButton";
export default {
  name: "EplNewPayment",
  computed: {
    ...mapGetters([
      "loggedIn",
      "paymentMethods",
      "payableAmount",
      "user",
      "paymentRequest"
    ])
  },
  components: {
    EplNewPaymentModeCard,
    EplNewPaymentSummaryCard,
    ActionButton
  },
  mounted() {
    this.$store.dispatch("paymentMethods");
  },
  data() {
    return {
      isLoyaltyPointsSelected: undefined
    };
  },
  methods: {
    payViaLoyalty() {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "PAYMENT_METHOD SELECTED",
        propertyName: "AMOUNT",
        propertyValue: "LOYALTY_POINTS"
      });
      this.$store
        .dispatch("loyaltyPoints", this.paymentRequest)
        .then(() => {
          this.paymentRequest.loyaltyPointsSelected = 0;
          this.$router.push({
            name: "PaymentSuccess"
          });
        })
        .catch(() => this.$router.push({ name: "PaymentFailure" }));
    }
  },
  watch: {
    isLoyaltyPointsSelected(val) {
      if (val) {
        this.paymentRequest.amount =
          this.paymentRequest.amount -
            this.paymentRequest.loyaltyPointsSelected <
          0
            ? 0
            : this.paymentRequest.amount -
              this.paymentRequest.loyaltyPointsSelected;

        this.paymentRequest.loyaltyPointsSelected =
          this.user.features.loyalty.redeemable_points > this.payableAmount
            ? this.payableAmount - this.user.features.loyalty.redeemable_points
            : this.user.features.loyalty.redeemable_points;
        this.paymentRequest.paymentMethod =
          this.user.features.loyalty.redeemable_points >= this.payableAmount
            ? "loyaltyPoints"
            : undefined;
      } else {
        this.paymentRequest.amount = this.payableAmount;
        this.paymentRequest.loyaltyPointsSelected = 0;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.payment {
  &__title {
    font-size: 16px;
    letter-spacing: 0.55px;
    color: #979797;
    background: #fafafa;
    padding-left: 26px;
    margin-bottom: 0;
    padding-top: 14px;
  }
  &__redeem-points {
    display: flex;
    align-items: center;
    padding: 1rem 2.6rem;
    &__checkbox {
      margin-right: 1rem;
      &__label {
        margin-bottom: 0;
        color: #979797;
        font-size: 1.6rem;
        &__available {
          font-size: 1.2rem;
          display: block;
          &--amount {
            color: #3482fd;
          }
        }
      }
    }
  }
  &__confirmation {
    padding: 1rem 2.6rem;
    &__title {
      font-size: 2rem;
      color: #787878;
      margin-bottom: 0;
    }
    &__detail-points {
      display: flex;
      justify-content: space-between;
      font-size: 1.8rem;
      &__title {
        color: #787878;
        margin-bottom: 0;
      }
      &__amount {
        color: #4d4d4d;
        font-weight: 500;
        margin-bottom: 0;
        &--primary {
          color: #3482fd;
        }
      }
    }
    &__detail-summary {
      font-size: 2rem;
      display: flex;
      justify-content: space-between;
      &__title {
        margin-bottom: 0;
        color: #4d4d4d;
        font-weight: 500;
      }
      &__amount {
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EplNewPayment.vue